module.exports = __webpack_public_path__ + "components/flag/static/square/tz-f211860367202e753419b67af899357d.svg";